import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Panning } from '@3ddv/ngx-sites-builder-lib';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';

@Component({
  selector: 'app-sbeditor-tool-panning',
  templateUrl: './panning.component.html',
  styleUrls: ['./panning.component.scss']
})
export class PanningComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public tool: Panning;
  @Output() exportTool = new EventEmitter<Panning>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      if(res.panning){
        this.tool = JSON.parse(JSON.stringify(res.panning));
      }else{
        console.error("panning tool not found");
        return;
      }

    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }
  
  onSelect($event): void{
    this.exportTool.emit(this.tool);
  }

  public getTool(){
    return this.tool;
  }
}
